import head from 'lodash/head'

export const getVenue = (state) => {
  const stand = head(state.stand.rvcs) || {}
  return stand.venue || {}
}
